import { useState, useEffect } from "react";

export const useWindowSize = (thresholdInPixels: number): boolean => {
    const [windowSize, setWindowSize] = useState(window.matchMedia(`(min-width: ${thresholdInPixels}px)`).matches);

    useEffect(() => {
        const windowSizeMatch = e => setWindowSize(e.matches);

        window
            .matchMedia(`(min-width: ${thresholdInPixels}px)`)
            .addEventListener('change', windowSizeMatch);

        return () => window.removeEventListener('change', windowSizeMatch);
    }, []);

    return windowSize;
}
